import messages from '../../locales/messages';
import { ADVANCED } from '../../constants/spread';
import { ReactElement, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import 'src/common/style/common.scss';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';

export interface thanksProps {
  offerings: string;
  volume: number;
  volumeRoundUp: number;
  tier: JSX.Element;
  price: string;
  bpName: string;
  advanced: boolean;
  bpConsentMail: boolean;
}

const Thanks = ({
  offerings,
  volume,
  volumeRoundUp,
  tier,
  bpName,
  advanced,
  price,
  bpConsentMail,
}: thanksProps): ReactElement => {
  const intl = useIntl();
  const [, setShowThanksModal] = useState(true);
  const titleThanks: thanksTable[] = [
    { group: 'title', value: 'Thank you!' },
    {
      group: 'subTitle',
      value: 'We have received your request',
    },
  ];
  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: 'Request details:',
    },
  ];
  const contentThanks: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages['thankyou_offering'])),
      value: String(offerings),
    },
  ];
  offerings == ADVANCED &&
    contentThanks.push({
      group: String(
        intl.formatMessage(messages['thankyou_private_data_connectivity']),
      ),
      value: advanced ? 'Yes' : 'No',
    });
  contentThanks.push({
    group: String(intl.formatMessage(messages['summary_api_call_volume'])),
    value: String(volume),
  });
  {
    offerings === ADVANCED
      ? contentThanks.push({
          group: String(
            intl.formatMessage(messages['summary_bucket_to_volume']),
          ),
          value: String(tier),
        })
      : contentThanks.push({
          group: String(intl.formatMessage(messages['api_call_rounded_up'])),
          value: String(volumeRoundUp),
        });
  }
  contentThanks.push({
    group: String(intl.formatMessage(messages['estimated_monthly_cost'])),
    value: String(price),
  });
  bpName &&
    contentThanks.push({
      group: 'Selected Business Partner: ',
      value: bpName,
    });
  bpName &&
    contentThanks.push({
      group: 'I consent to IBM providing my business contact information: ',
      value: bpConsentMail ? 'Yes' : 'No',
    });
  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages['returnToEstimator'])),
    },
  ];
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    setShowModal(true);
  }, [
    offerings,
    volume,
    volumeRoundUp,
    tier,
    bpName,
    advanced,
    price,
    bpConsentMail,
  ]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="API connect PE page"
      object="API Connect Pricing Page"
      productTitle={'API Connect Price estimator'}
      pageUrl={''}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    ></ThanksModal>
  );
};

export default Thanks;
